import { DefaultPosition } from '../../PanelTemplatesTheme/constants';
import { Panel } from '../../../../models/Panel/Panel';
import { HyperSpaceQuadrantMatrix } from '../widgets/HyperSpaceQuadrantMatrix';

export const TemplateHyperSpaceQuadrantMatrix: Panel = {
    id: 'hyper-space-quadrant-matrix',
    name: 'Quadrant Matrix',
    description: '',
    tags: ['Standard', 'Quadrant Matrix', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_quadrant_matrix',
        children: [
            {
                ...HyperSpaceQuadrantMatrix,
                position: DefaultPosition,
            },
        ],
    },
};
